import styled from "styled-components";
import GooglePlay from "../../../assets/images/google-play-badge.png";
import GooglePlayEn from "../../../assets/images/google-play-badge-en2.png";
import AppStore from "../../../assets/images/app-store-badge.png";
import AppStoreEn from "../../../assets/images/app-store-badge-en.png";
import { useTranslation } from "react-i18next";

const Badge = styled.img`
  cursor: pointer;
  height: 2em;
  width: 111px;  
  padding-right: 5px;
  z-index: 2;
`;

const BadgeIos = styled.img`
  cursor: pointer;
  height: 2em;
  width: 99px;  
  z-index: 2;
`;

const Span = styled.span`
  font-size: 14px;
  line-height: 150%;
  color: rgb(242, 169, 0);
`;

const H1 = styled.h1`
  font-family: KBFGDisplay;
  font-weight: bold;
  font-size: 32px;
  line-height: 48px;
  color: rgb(94, 81, 77);
`;

const P = styled.p`
  font-weight: 400;
  line-height: 150%;
  color: rgb(94, 81, 77);
`;

const A = styled.a`
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: rgb(0, 0, 0);
  background: rgb(242, 169, 0);
  text-align: center;
`;

const Img = styled.img`
  width: 100%;
  border-radius: 0px 40px;
  height: 254px;
  object-fit: cover;

  @media (min-width: 768px) {
    height: 320px;
  }
`;

const HeaderSection = function ({
  title,
  showButton = false,
  group,
  description,
  textButton,
  linkButton,
  banner,
}) {

  let Google = '';
  let Apple = '';
  let value = description;

  const { i18n } = useTranslation();

  if(typeof value != "undefined")
  {
    if(value?.indexOf('[BTN_GPS]') > -1)
    {
      value = value.replace('[BTN_GPS]', '');
      Google = (<Badge src={i18n.language === "id" ? GooglePlay : GooglePlayEn} height="10em" onClick={() => window.open("https://play.google.com/store/apps/details?id=com.flutter.wokee_platform", "_blank")} />)      
    }
  
    if(value?.indexOf('[BTN_APPSTR]') > -1)
    {
      value = value.replace('[BTN_APPSTR]', '');
      Apple = (<BadgeIos src={i18n.language === "id" ? AppStore : AppStoreEn} onClick={() => window.open("https://apps.apple.com/id/app/wokee/id1527371371", "_blank")} />)
    }
  }

  return (
    <div className="p-0 m-0 container-fluid">
      <div className="pt-4 px-3 pb-0">
        <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
          <div className="mb-4 p-0 order-lg-2 col-md-7 col-12">
            <Img src={banner} />
          </div>
          <div className="p-0 pe-lg-5 order-lg-1 col-md-5 col-12">
            <Span>{group}</Span>
            <H1>{title}</H1>
            <P dangerouslySetInnerHTML={{ __html: value }}></P>
            <div>                        
              {Google !== '' && Google}
              {Apple !== '' && Apple}
            </div>
            {showButton && (
              <div className="d-grid col-lg-8 mt-4">
                <A className="btn btn-primary btn-lg" href={linkButton}>
                  {textButton}
                </A>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;
